import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { finalize } from 'rxjs';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';
import { RouterModule } from '@angular/router';
import { ArticleLinkData, Article, ArticleService } from '../../../shared/public-api';

@Component({
  selector: 'admin-article-link',
  templateUrl: './article-link.component.html',
  styleUrls: ['./article-link.component.scss'],
  imports: [CommonModule, SkeletonModule, RouterModule],
})
export class ArticleLinkComponent extends BaseComponent<ArticleLinkData> implements AfterViewInit {
  @ViewChild('articleLink', { static: false }) articleLink: ElementRef;
  articleId = '';
  loading = true;
  article: Article;
  articleImageSrc: string;

  constructor(
    private readonly articleService: ArticleService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private readonly cd: ChangeDetectorRef
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this.articleId = this.data.articleId;
    this.articleService
      .getArticle(this.articleId)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cd.detectChanges();
          this.setImageClass();
        })
      )
      .subscribe((article) => {
        this.article = article;
        this.articleImageSrc = `
          linear-gradient(0deg, rgba(0, 0, 0, 0.5) 20%, rgba(0, 0, 0, 0) 35%),
          url("${article.coverPicture?.src.replace(/\\/g, '/')}")
          `;
      });
  }

  @HostListener('window:resize')
  setImageClass(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const elementHeight = this.articleLink.nativeElement.offsetHeight;
    const elementWidth = this.articleLink.nativeElement.offsetWidth;

    const pictureHeight = this.article?.coverPicture?.height ?? 0;
    const pictureWidth = this.article?.coverPicture?.width ?? 0;

    const widthRatio = pictureWidth / elementWidth;
    const heightRatio = pictureHeight / elementHeight;
    if (heightRatio < widthRatio) {
      this.articleLink.nativeElement.className = 'article large';
    } else {
      this.articleLink.nativeElement.className = 'article';
    }
  }
}
